document.addEventListener('DOMContentLoaded', function () {
  var wrapper = document.getElementById('stk-wrapper');
  if (!wrapper) { console.warn('StickyATC: #stk-wrapper missing'); return; }

  // ❗ FIXED: Button is class="stk-cta", not id
  var addBtn = document.querySelector('.stk-cta');

  // If button missing (OOS block), stop script cleanly
  if (!addBtn) {
    console.warn("StickyATC: No Add to Cart button found (OOS variant?)");
    return;
  }

  // If OOS button → disable functionality fully
  if (addBtn.disabled) {
    console.log("StickyATC: OOS button detected, ATC disabled.");
    return;
  }

  var variantInput = document.getElementById('stk-variant-id');
  var qtyInput = document.getElementById('stk-qty');
  var msg = document.getElementById('stk-message');

  var leftPriceEl = document.querySelector('.stk-current-price');
  var leftCompareEl = document.querySelector('.stk-original-price');

  var defaultPrice = wrapper.getAttribute('data-default-price') || '';
  var defaultCompare = wrapper.getAttribute('data-default-compare') || '';

  /* --- your price and variant logic remains unchanged --- */

  // ---------- ADD-TO-CART BUTTON FIX ----------
  addBtn.addEventListener('click', function (ev) {
    ev.preventDefault();

    // prevent click again
    var orig = addBtn.textContent;
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';

    // get variant id
    var variantId =
      (variantInput && variantInput.value) ||
      wrapper.getAttribute('data-override-variant') ||
      '';

    if (!variantId) {
      console.error("StickyATC: Missing variant ID");
      addBtn.disabled = false;
      addBtn.textContent = orig;
      return;
    }

    var qty = parseInt(qtyInput && qtyInput.value ? qtyInput.value : 1, 10) || 1;

    // Primary AJAX Add
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (res) {
        if (!res.ok)
          return res.text().then(function (t) {
            throw { stage: 'json', status: res.status, body: t };
          });
        return res.json();
      })
      .then(function (json) {
        updateCartCount();
        addBtn.textContent = 'Added';
        setTimeout(function () {
          addBtn.textContent = orig;
          addBtn.disabled = false;
        }, 900);
      })
      .catch(function (err) {
        console.warn('Primary add failed → fallback', err);

        // fallback form submit
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', qty);

        fetch('/cart/add', {
          method: 'POST',
          credentials: 'same-origin',
          body: fd
        })
          .then(function (r) {
            if (!r.ok)
              return r.text().then(function (t) {
                throw { stage: 'form', status: r.status, body: t };
              });
            return r;
          })
          .then(function () {
            updateCartCount();
            addBtn.textContent = 'Added';
            setTimeout(function () {
              addBtn.textContent = orig;
              
              addBtn.disabled = false;
            }, 900);
          })
          .catch(function (e) {
            console.error('Fallback add failed', e);
            addBtn.textContent = orig;
            addBtn.disabled = false;
          });
      });
  });

  // ---------- UPDATE CART COUNT ----------
  function updateCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => {
        document.querySelectorAll('.cart-count, [data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  }

});